import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/wingman/90e46ca0-3fa9-4130-be27-717d128595f6/attachments/639a5dd5d1024e7890bba17e29a6f5ff_8b2fa59b-77b8-48db-8df6-38736c98cc17.png";

export const CATEGORIES = [
  { id: "deneigement", label: "Déneigement", icon: "Snowflake" },
  { id: "livraison_colis", label: "Livraison colis", icon: "Package" },
  { id: "commissions", label: "Commissions", icon: "ShoppingBag" },
  { id: "epicerie", label: "Épicerie", icon: "ShoppingCart" },
  { id: "montage_meubles", label: "Montage meubles", icon: "Hammer" },
  { id: "petits_travaux", label: "Petits travaux", icon: "Wrench" },
  { id: "aide_domicile", label: "Aide à domicile", icon: "Home" },
  { id: "transport_objets", label: "Transport d'objets", icon: "Truck" },
  { id: "jardinage", label: "Jardinage", icon: "Flower2" },
  { id: "menage_leger", label: "Ménage léger", icon: "Sparkles" },
  { id: "aide_demenagement", label: "Aide déménagement", icon: "Boxes" },
  { id: "course_deplacement", label: "Course / déplacement", icon: "Car" },
  { id: "navette_aeroport", label: "Navette aéroport", icon: "Plane" },
  { id: "autres", label: "Autres tâches", icon: "MoreHorizontal" },
];

export const STATUS_LABELS = {
  published: { fr: "Publiée", color: "bg-surface text-navy" },
  accepted: { fr: "Acceptée", color: "bg-amber-100 text-amber-800" },
  paid: { fr: "Paiement reçu", color: "bg-blue-100 text-blue-800" },
  on_the_way: { fr: "Helper en route", color: "bg-indigo-100 text-indigo-800" },
  completed: { fr: "Complétée", color: "bg-lime text-navy" },
  confirmed: { fr: "Confirmée", color: "bg-green-100 text-green-800" },
  paid_out: { fr: "Payée", color: "bg-green-200 text-green-900" },
  cancelled: { fr: "Annulée", color: "bg-red-100 text-red-800" },
  dispute: { fr: "Litige", color: "bg-orange-100 text-orange-800" },
};

export const TRAVEL_TIERS = [
  { id: "0_5", label: "0 – 5 km", fee: 0, hint: "Inclus dans le prix" },
  { id: "5_15", label: "5 – 15 km", fee: 5, hint: "+ 5 $" },
  { id: "15_30", label: "15 – 30 km", fee: 10, hint: "+ 10 $" },
  { id: "manual", label: "30 km et +", fee: null, hint: "À discuter / saisir" },
];

export const AIRPORTS = [
  { code: "YUL", label: "Montréal-Trudeau" },
  { code: "YQB", label: "Québec-J.-Lesage" },
  { code: "YMX", label: "Mirabel" },
];

export const resolveTravelFee = (tier, manual) => {
  if (tier === "manual") return Math.max(0, Number(manual) || 0);
  const t = TRAVEL_TIERS.find((x) => x.id === tier);
  return t ? t.fee : 0;
};

export const computePricing = (base_price, urgent, travel_fee = 0) => {
  const urgency_fee = urgent ? +(base_price * 0.3).toFixed(2) : 0;
  const tf = +Number(travel_fee || 0).toFixed(2);
  const helper_subtotal = +(base_price + urgency_fee + tf).toFixed(2);
  const commission = +(helper_subtotal * 0.15).toFixed(2);
  const fixed_fee = 3;
  const go_helper_fee = +(fixed_fee + commission).toFixed(2);
  const total = +(helper_subtotal + go_helper_fee).toFixed(2);
  return { base_price, urgency_fee, travel_fee: tf, helper_subtotal, fixed_fee, commission, go_helper_fee, total };
};
